module.exports = __webpack_public_path__ + "static/media/_Collage.7aa1ca95.png";